import { EPanelDirections } from '@/store/slices/layout-grid/types';
import useSetLayout from '@layouts/layout-grid/layout-utils/use-set-layout';

export const createEditProjectLayoutDimensions = {
  columns: {
    maxWidth: 'calc(1440px - 96px - 96px)',
  },
  panel: {
    borderColor: 'transparent',
    width: '220px',
  },
  main: {
    minWidth: 'calc(992px + 40px)',
  },
};

const useCreateEditProjectLayout = ({ preventUpdate }: { preventUpdate: boolean }) => {
  useSetLayout(
    {
      direction: EPanelDirections.LTR,
      panelOpen: false,
      oppositePanelOpen: false,
      footerOpen: false,
      pillarOpen: false,
      headerOpen: true,
    },
    { preventUpdate }
  );
};

export default useCreateEditProjectLayout;
